import Component from '@glimmer/component';
import { action, set } from '@ember/object';

export default class MwReschedule extends Component {
  @action
  startEditing() {
    set(this.args.post, 'isEditingSchedule', true);
  }
}
